const STORES: Set<any> = new Set()

export function register<T>(store: T): T {
  STORES.add(store)
  return store
}

export function allStores() {
  return [...STORES]
}